import { MessageCircleQuestion } from "lucide-react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";
import { Reveal } from "../components/Reveal";
import { SectionTag } from "../components/SectionLabel";

const FAQS = [
  {
    q: "Vocês atendem online?",
    a: "Sim. Atendimento por vídeo ou telefone, com a mesma atenção do presencial.",
  },
  {
    q: "O primeiro atendimento é pago?",
    a: "Fazemos uma triagem inicial sem custo para entender seu caso antes de qualquer cobrança.",
  },
  {
    q: "Vocês atendem empresas e pessoas físicas?",
    a: "Sim, atuamos para empregados, empresas e também apoiamos outros escritórios.",
  },
  {
    q: "Como funciona a cobrança?",
    a: "Depende do caso — pode ser honorário fixo, êxito ou contrato de assessoria. Explicamos tudo antes de começar.",
  },
  {
    q: "Em quanto tempo vocês respondem?",
    a: "Normalmente em até 24h úteis, direto com quem vai conduzir o seu caso.",
  },
  {
    q: "Vocês também atendem outros escritórios?",
    a: "Sim, apoiamos em audiências, sustentações orais e pareceres estratégicos.",
  },
];

export const FAQ = () => (
  <section id="faq" className="bg-cream py-24 lg:py-32" data-testid="faq-section">
    <div className="max-w-3xl mx-auto px-6 lg:px-10">
      <Reveal>
        <SectionTag icon={MessageCircleQuestion} label="Perguntas frequentes" tone="brown" />
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-ink mb-14">
          Dúvidas rápidas, respostas diretas.
        </h2>
      </Reveal>

      <Reveal delay={0.15}>
        <Accordion type="single" collapsible className="w-full">
          {FAQS.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border-b border-line"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger
                className="font-serif text-lg sm:text-xl text-ink text-left hover:text-teal-dark py-6"
                data-testid={`faq-trigger-${i}`}
              >
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-ink-soft text-base leading-relaxed pb-6">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
